import React from 'react'
import { useRouter } from 'next/router'
import JoinButton from '../profile/group/actions/JoinButton'
import JoinPlatformButton from './JoinPlatformButton'
import useUser from '../../lib/useUser'
import useGroup from '../../lib/useGroup'
import { useTranslation } from '../../lib/i18n'

const ParticipationPrompt = ({
  className = 'flex justify-center items-center flex-col gap-2 border-t border-divider pt-4',
  item,
}) => {
  const router = useRouter()
  const { invite } = router.query
  const itemSlug = item?.postable?.slug || item?.eventable?.slug
  const itemVisibility =
    item?.postable?.visibility || item?.eventable?.visibility
  const { user, isLoading } = useUser()
  const { canParticipate } = useGroup(itemSlug)
  const { t } = useTranslation()

  if (!user && !isLoading) {
    return (
      <div className={className}>
        <p className="text-offBlack text-center">
          {t('common.joinPlatformToParticipate')}
        </p>
        <JoinPlatformButton />
      </div>
    )
  }

  if (!canParticipate) {
    return (
      <div className={className}>
        <p className="text-offBlack text-center">
          {t('common.joinGroupToParticipate')}
        </p>
        <JoinButton
          groupSlug={itemSlug}
          visibility={itemVisibility}
          invite={invite}
        />
      </div>
    )
  }

  return null
}

export default ParticipationPrompt
